import routerEvents from '../react-router/events'
import {Obj} from '../utility'
import {getLocalConfig} from './config'
import {getCurrentLocaleCode} from './translator'

/**
 * Get direction of the given locale code
 *
 * @param   {string} localeCode
 * @returns {string}
 */
export function directionOf(localeCode: string) {
  return Obj.get(getLocalConfig('locales', {}), localeCode + '.direction', 'ltr')
}

/**
 * Get current direction
 *
 * @returns  {string}
 */
export function currentDirection() {
  return directionOf(getCurrentLocaleCode())
}

/**
 * Check current direction
 * @param dir
 * @returns
 */
export function directionIs(dir: 'ltr' | 'rtl') {
  return currentDirection() === dir
}

export function isRtl() {
  return directionIs('rtl')
}

/**
 * update page dir
 *
 * @param localeCode
 * @returns
 */
export function updateLocaleCode(localeCode: string) {
  if (localeCode === getCurrentLocaleCode()) return

  document.documentElement.dir = directionOf(localeCode)

  document.documentElement.lang = localeCode
}
